import React from 'react';
import LinearProgress from '@fv-components/linear-progress';
import Taskpane from './Taskpane/Taskpane';
import OfficeTaskpane from './TaskpaneOffice/OfficeTaskpane';
import SigninAction from './fvid-auth/signinAction';
import { useAuth } from './fvid-auth/authContext';
import MsalLanding from './Msal/MsalLanding';
import SignoutMenu from './SignoutMenu/SignoutMenu';
import FullPageError from './FullPageError';

export default function App({ isOutlook, isWord, isExcel, isPowerPoint, currentEmailId }: { isOutlook: boolean; isWord: boolean; isExcel: boolean; isPowerPoint: boolean; currentEmailId: string | undefined }) {
  const { user, isLoading, isMsalLoading, validatedMSAL, authError } = useAuth();

  if (isLoading || isMsalLoading) {
    return <LinearProgress />;
  }

  return (
    <div className="app-container">
      {authError && <FullPageError errorMessage={authError} />}
      {!authError && !user && <SigninAction />}
      {!authError && user && !validatedMSAL && <MsalLanding />}
      {!authError && user && validatedMSAL && (
        <>
        <div className="taskpane-container">
          {isOutlook && <Taskpane currentEmailId={currentEmailId} />}
          {!isOutlook && (isWord || isExcel || isPowerPoint) && <OfficeTaskpane />}
        </div>
        <SignoutMenu />
        </>
      )}
    </div>
  );
}
